<template>
  <div class="tab-dialog-box" style="position: relative;">
    <el-tabs v-model="activeFragmentId">
      <el-tab-pane label="考勤组" name="EditAttnGroup" style="width: 100%;"
        v-if="checkPermCodeExist('EditAttnGroup:EditAttnGroup')">
        <el-scrollbar class="custom-scroll" :style="{height: getTabPaneHeight + 'px'}">
          <el-form ref="EditAttnGroupFilter" :model="EditAttnGroup" :size="defaultFormItemSize"
            label-width="100px" label-position="right" @submit.native.prevent
          >
            <filter-box :item-width="350">
              <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditAttnGroup:EditAttnGroup:update')"
                @click="onUpdateClick()">
                保存
              </el-button>
            </filter-box>
          </el-form>
          <el-form ref="EditAttnGroup" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
            label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="名称" prop="PaAttnGroup.name">
                  <el-input class="input-item" v-model="formData.PaAttnGroup.name"
                    :clearable="true" placeholder="名称"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="允许外勤" prop="PaAttnGroup.anywhereFlag">
                  <el-select class="input-item" v-model="formData.PaAttnGroup.anywhereFlag" :clearable="true" filterable
                    placeholder="允许外勤" :loading="EditAttnGroup.anywhereFlag.impl.loading"
                    @visible-change="EditAttnGroup.anywhereFlag.impl.onVisibleChange"
                    @change="onAnywhereFlagValueChange">
                    <el-option v-for="item in EditAttnGroup.anywhereFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="描述" prop="PaAttnGroup.detail">
                  <el-input class="input-item" v-model="formData.PaAttnGroup.detail"
                    :clearable="true" placeholder="描述"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="备注" prop="PaAttnGroup.remark">
                  <el-input class="input-item" v-model="formData.PaAttnGroup.remark"
                    :clearable="true" placeholder="备注"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24" class="gutter-bottom">
                <el-card class="base-card" shadow="never">
                  <div slot="header" class="base-card-header">
                    <span>考勤地点</span>
                    <div class="base-card-operation">
                      <el-button @click="onAddAttnGroupLineClick()" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('EditAttnGroup:EditAttnGroup:AddAttnGroupLine')">
                        添加
                      </el-button>
                    </div>
                  </div>
                  <el-row class="no-scroll" :gutter="20">
                    <el-col class="table-box gutter-bottom" :span="24">
                      <el-table ref="paAttnGroupLine" :data="EditAttnGroup.PaAttnGroupLine.impl.dataList" :size="defaultFormItemSize" @sort-change="EditAttnGroup.PaAttnGroupLine.impl.onSortChange"
                        header-cell-class-name="table-header-gray"
                      >
                        <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="EditAttnGroup.PaAttnGroupLine.impl.getTableIndex" />
                        <el-table-column label="地点" prop="position">
                        </el-table-column>
                        <el-table-column label="上班时间" prop="attnInTime">
                        </el-table-column>
                        <el-table-column label="下班时间" prop="attnOutTime">
                        </el-table-column>
                        <el-table-column label="允许偏差(分钟)" prop="attnAllowTime">
                        </el-table-column>
                        <el-table-column label="经度" prop="longitude">
                        </el-table-column>
                        <el-table-column label="纬度" prop="latitude">
                        </el-table-column>
                        <el-table-column label="半径(米)" prop="radius">
                        </el-table-column>
                        <el-table-column label="详情" prop="detail">
                        </el-table-column>
                        <el-table-column label="备注" prop="remark">
                        </el-table-column>
                        <el-table-column label="操作" fixed="right">
                          <template slot-scope="scope">
                            <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                              :disabled="!checkPermCodeExist('EditAttnGroup:EditAttnGroup:delete')">
                              删除
                            </el-button>
                            <el-button @click.stop="onEditAttnGroupLineClick(scope.row)" type="text" :size="defaultFormItemSize"
                              :disabled="!checkPermCodeExist('EditAttnGroup:EditAttnGroup:EditAttnGroupLine')">
                              编辑
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </el-form>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaAttnGroupController, PaAttnGroupLineController, DictionaryController } from '@/api';
import editAttnGroupLine from '@/views/AttnManage/editAttnGroupLine.vue';
import addAttnGroupLine from '@/views/AttnManage/addAttnGroupLine.vue';

export default {
  name: 'EditAttnGroup',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      activeFragmentId: 'EditAttnGroup',
      formData: {
        PaAttnGroupLine: {
          id: undefined,
          attnAllowTime: undefined,
          attnGroupId: undefined,
          attnInTime: undefined,
          attnOutTime: undefined,
          position: undefined,
          longitude: undefined,
          latitude: undefined,
          radius: undefined,
          detail: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaAttnGroup.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      EditAttnGroup: {
        formFilter: {
        },
        formFilterCopy: {
        },
        PaAttnGroupLine: {
          impl: new TableWidget(this.loadPaAttnGroupLineWidgetData, this.loadPaAttnGroupLineVerify, false, false, 'createTime', 1)
        },
        anywhereFlag: {
          impl: new DropdownWidget(this.loadAnywhereFlagDropdownList)
        },
        AttnPositionDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 考勤组行数据获取函数，返回Promise
     */
    loadPaAttnGroupLineWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paAttnGroupLineDtoFilter: {
          attnGroupId: this.id
        }
      }
      return new Promise((resolve, reject) => {
        PaAttnGroupLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 考勤组行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaAttnGroupLineVerify () {
      return true;
    },
    /**
     * 允许外勤下拉数据获取函数
     */
    loadAnywhereFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 允许外勤选中值改变
     */
    onAnywhereFlagValueChange (value) {
    },
    /**
     * 更新考勤地点
     */
    refreshAttnPositionDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable(true, 1);
      } else {
        this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable();
      }
      this.EditAttnGroup.AttnPositionDiv.isInit = true;
    },
    /**
     * 更新考勤组
     */
    refreshEditAttnGroup (reloadData = false) {
      this.loadPaAttnGroupData().then(res => {
        if (reloadData) {
          this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable(true, 1);
        } else {
          this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable();
        }
        if (!this.EditAttnGroup.isInit) {
          // 初始化下拉数据
        }
        this.EditAttnGroup.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditAttnGroup.validate((valid) => {
        if (!valid) return;
        let params = {
          paAttnGroupDto: {
            id: this.formData.PaAttnGroup.id,
            name: this.formData.PaAttnGroup.name,
            anywhereFlag: this.formData.PaAttnGroup.anywhereFlag,
            detail: this.formData.PaAttnGroup.detail,
            remark: this.formData.PaAttnGroup.remark
          }
        };

        PaAttnGroupController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.refreshEditAttnGroup();
        }).catch(e => {});
      });
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaAttnGroupLineController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditAttnGroupLineClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editAttnGroupLine, {
        area: '400px'
      }, params).then(res => {
        this.EditAttnGroup.PaAttnGroupLine.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddAttnGroupLineClick () {
      let params = {
        attnGroupId: this.id
      };

      this.$dialog.show('添加', addAttnGroupLine, {
        area: '400px'
      }, params).then(res => {
        this.refreshAttnPositionDivWidget();
      }).catch(e => {});
    },
    onResume () {
      let activeFragment = this.getActiveFragment();
      if (activeFragment != null) activeFragment.refresh();
    },
    /**
     * 获取考勤组详细信息
     */
    loadPaAttnGroupData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaAttnGroup.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaAttnGroupController.view(this, params).then(res => {
            this.formData.PaAttnGroup = {...res.data, isDatasourceInit: true};
            if (this.formData.PaAttnGroup.anywhereFlagDictMap && this.EditAttnGroup.anywhereFlag.impl.dirty) {
              this.EditAttnGroup.anywhereFlag.impl.dropdownList = [this.formData.PaAttnGroup.anywhereFlagDictMap];
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaAttnGroupLine: {
          id: undefined,
          attnAllowTime: undefined,
          attnGroupId: undefined,
          attnInTime: undefined,
          attnOutTime: undefined,
          position: undefined,
          longitude: undefined,
          latitude: undefined,
          radius: undefined,
          detail: undefined,
          remark: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          isDatasourceInit: false
        },
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditAttnGroup();
    }
  },
  computed: {
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
  }
}
</script>
